import i18n from 'i18next'
import { LOCALE_TO_INTL, toAppLocale } from './locale'

/** Число с разделителем разрядов по языку интерфейса, без знака валюты.
 *
 *  Нужен там, где валюта своя: баланс участника приходит с кодом валюты от
 *  бэка, а `formatPrice` жёстко подставляет тенге. Без общего хелпера баннер
 *  баланса печатал сумму голым числом, и «998500» стояло рядом с «998 500» в
 *  шапке — читалось как разные суммы. */
export function formatAmount(amount: number): string {
  return amount.toLocaleString(LOCALE_TO_INTL[toAppLocale(i18n.language)])
}

/** Балл или среднее: по локали интерфейса, не больше одного знака после запятой,
 *  целое без хвоста («24.0» → «24»). Один формат на всех экранах, где бэк
 *  отдаёт дробные баллы; счётчики (участники, места) — `formatAmount`. */
export function formatScore(value: number): string {
  return value.toLocaleString(LOCALE_TO_INTL[toAppLocale(i18n.language)], {
    maximumFractionDigits: 1,
  })
}

export function formatPrice(amount: number): string {
  return `${formatAmount(amount)} ₸`
}

export function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 B'
  const k = 1024
  const sizes = ['B', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(1))} ${sizes[i]}`
}
